<template>
    <q-list>
        <q-item
            v-for="item in items"
            :key="item.id"
            v-bind="itemProps"
            :clickable="!item.disabled"
            class="q-px-none"
            @click="item.is_selected = !item.is_selected"
        >
            <q-item-section side>
                <form-checkbox v-model="item.is_selected" :disable="item.disabled" />
            </q-item-section>

            <q-item-section>
                <slot :item="item" />
            </q-item-section>
        </q-item>
    </q-list>
</template>

<script setup>
defineProps({
    items: Array,
    itemProps: Object,

    // Key to use in each item to represent whether the item is selected/checked or not
    selectionKey: {
        type: String,
        default: 'is_selected',
    },
})
</script>
